import { schema } from "normalizr"
import createdBy from "../createdBy/item"
import userLicenceModules from "../userLicenceModules"

export default new schema.Entity(
  "userDetails",
  {
    createdBy,
    userLicenceModules,
  },
  {
    idAttribute: "userId",
  }
)
